module.exports = __webpack_public_path__ + "media/stylesheets/images/home_banner-a20cc06bc04b4982aef1ab2ae066150d.png";